export const mainColor = "#f1d713";

// create an utility function somewhere
export const checkImage = (path) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(path);
    img.onerror = () => reject();

    img.src = path;
  });

export function slugify(titleStr) {
  if (!titleStr) {
    alert("لطفا عنوان را وارد کنید!");
  }
  titleStr = titleStr.replace(/^\s+|\s+$/g, "");
  titleStr = titleStr.toLowerCase();
  //persian support
  titleStr = titleStr
    .replace(/[^a-z0-9_\s-ءاأإآؤئبتثجحخدذرزسشصضطظعغفقكلمنهويةى]#u/, "")
    // Collapse whitespace and replace by -
    .replace(/\s+/g, "-")
    // Collapse dashes
    .replace(/-+/g, "-");
  return titleStr;
}

function twoDigits(d) {
  if (0 <= d && d < 10) return "0" + d.toString();
  if (-10 < d && d < 0) return "-0" + (-1 * d).toString();
  return d.toString();
}
export function toMysqlDate(date) {
  const getTime = (date.toMysqlFormat = () => {
    return (
      date.getUTCFullYear() +
      "-" +
      twoDigits(1 + date.getUTCMonth()) +
      "-" +
      twoDigits(date.getUTCDate()) +
      " " +
      twoDigits(date.getUTCHours()) +
      ":" +
      twoDigits(date.getUTCMinutes()) +
      ":" +
      twoDigits(date.getUTCSeconds())
    );
  });
  return getTime();
}

export function toEnglishDigits(string) {
  var num_dic = {
    "۰": "0",
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
  };

  return parseInt(
    string.replace(/[۰-۹]/g, function (w) {
      return num_dic[w];
    })
  );
}
